/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
import * as React from "react";
import { useDexterTheme } from "../DesignSystem/Theme/ThemeContext";
import { TransformTypeDescriptor } from "Api";

function formatPrimitive(primitive): React.ReactNode {
  return primitive || <span style={{ color: "#888" }}>N/A</span>;
}

export function TransformDetailsTooltipContent({
  descriptor,
}: {
  descriptor: TransformTypeDescriptor;
}): JSX.Element {
  const { currentTheme } = useDexterTheme();

  return (
    <div
      style={{
        minWidth: 320,
        maxWidth: 400,
        fontFamily: currentTheme.fonts.primary,
        color: currentTheme.colors.tooltipText,
        padding: 8,
      }}
    >
      <div
        style={{
          fontWeight: 700,
          fontSize: 18,
          marginBottom: 10,
          color: currentTheme.colors.tooltipText,
        }}
      >
        {descriptor.displayName}
      </div>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ textAlign: "left", padding: 8 }}>Field</th>
            <th style={{ textAlign: "left", padding: 8 }}>Input</th>
            <th style={{ textAlign: "left", padding: 8 }}>Output</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ padding: 8 }}>Container Type</td>
            <td style={{ padding: 8 }}>
              {descriptor.input?.containerType || "—"}
            </td>
            <td style={{ padding: 8 }}>
              {descriptor.output?.containerType || "—"}
            </td>
          </tr>
          <tr>
            <td style={{ padding: 8 }}>Primitive Type</td>
            <td style={{ padding: 8 }}>
              {formatPrimitive(descriptor.input?.primitiveType)}
            </td>
            <td style={{ padding: 8 }}>
              {formatPrimitive(descriptor.output?.primitiveType)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
